/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getAdvertisementDetails, getActiveAdvertisementForDocumentApprovalList, getCancelRejectApplication, getPastAdvertisementForDocumentApprovalList, getAllAdvertisementForDocumentApprovalList, getActiveAdvertisementDetails, getPastAdvertisementDetails } from "../../documentsverification/actions/documentVerificationAction";
import { getDocumentTypeListPagination, getQualificationTypeListPagination, getQualificationNameListPagination, getQualSubjectTypeListPagination, getUniversityListPagination, getStatesListPagination, getStageListPagination, getLookupOptionListPagination, getDistrictListPagination, getTalukaListPagination, getVillageListPagination, getExamSubjectsListPagination, getRequisitionPostListPagination, getSpecialisationListPagination, getRequisitionDepartmentListPagination, getInstitutionListPagination, getAllGrievanceListPagination } from "../../admin/masterManagement/actions/masterManagementAction.js";
import { getAllApprovedVenuesListPagination, getAllApprovalVenuesListPagination, getAllActiveVenueAdvtList } from "../../venuemanagement/actions/venueManagementAction";
import { getAllRequisitionListPagination } from "../../requisitionmanagement/actions/requisitionManagementAction";
// import {  getDepartmentWiseReportListPagination, getAllRequisitionDataReportListPagination } from "../../reports/actions/reportsManagementAction";
import { getDashboardsUserListData, getAttendentListData, getAllExamsListPagination, getDebarredListPagination, getAllDocumentListPagination, collectorAttendancePagination, getVenueAdvertisementListAPI, getNonAssignedVenueAdvertisementListAPI } from "../../dashboard/actions/dashboardAction";
import { getAllAdvertisementReportListPagination, getDepartmentWiseReportListPagination, getAllRequisitionDataReportListPagination, getFilterAdvertisementReportListPagination } from "../../reports/actions/reportsManagementAction";
// import { getDashboardsUserListData, getAttendentListData, getAllExamsListPagination, getDebarredListPagination, getAllDocumentListPagination, collectorAttendancePagination } from "../../dashboard/actions/dashboardAction";
// import { getReUploadApplicationDocList, getReDownloadApplicationDocList, getAllObjectionFilesData, getSearchAdmitCardListData } from '../../applicationstages/actions/applicationStagesAction';
import { getReUploadApplicationDocList, getReDownloadApplicationDocList, getAllObjectionFilesData, getSearchAdmitCardListData } from '../../applicationstages/actions/applicationStagesAction.js';
import { getAdvertisement, getPastAdvertisement, getChallanCandidates } from '../../challanmanagement/actions/challanManagementAction';
import { getTimetableCsvList } from '../../timetablemanagement/actions/timetableManagementAction';
import { getAllApprovalUser } from '../../admin/usermanagement/actions/userAction.js';
import { getPendingRequisitionDataDetails, getSentForApprovalRequisitionDataDetails, getPendingApprovalRequisitionDataDetails } from '../../requitionDashboard/actions/requisitionDashboardAction';
import { getAllDebarUsers } from '../../admin/debarManagement/actions/debarManagementActions.js';
import _, { prop } from "lodash/fp";
import commonLabels from '../../common/labels/common_en.json';
import { getAllAdvertisementListAPI } from '../../candidatedatamanagement/actions/candidateDataManagementAction';

//component to create pagination
const TablePagination = (props) => {
    const dispatch = useDispatch();
    const [pageNumber, setPageNumber] = useState(1);
    //set row per page
    const rowPerPage = props.rowPerPage ? props.rowPerPage : 10;
    //total count
    const totalApplication = props.totalCount ? props.totalCount : 50;

    const searchCode1 = props.searchMode && props.textToSearch ? props.textToSearch : false;
    const searchCode2 = props.searchCode2 ? props.searchCode2 : false;
    const searchCode3 = props.searchCode3 ? props.searchCode3 : false;


    props.setListCurrentPage && props.setListCurrentPage(pageNumber - 1);
    useEffect(() => {
        setPageNumber(1)
     props.listCurrentPage &&   setPageNumber(props.listCurrentPage+1)
    }, [props.totalCount, props.searchMode])


    //to set totalpage required for total  list
    const pagesForTotalApplication = Math.floor(totalApplication / rowPerPage)
    let totalCount = Number.isInteger(totalApplication / rowPerPage) ? pagesForTotalApplication : pagesForTotalApplication + 1

    let pageCounter = new Array();
    for (var i = 1; i <= totalCount; i++) {
        pageCounter[i] = i;
    }

    let enablePrev = pageNumber != 1;
    let enableLast = pageNumber != totalCount;

    const nextPageData = () => {

        if (props.onChangeValue) {
            gotoFirstPage()
            props.setonChangeValue(false);
        }

        if ((pageNumber < totalCount) && (pageNumber !== totalCount) && pageNumber > 0) {
            setPageNumber(parseInt(pageNumber) + 1);
            // eslint-disable-next-line default-case
            switch (props.paginationFor) {
                case "active_advt_list":
                    return dispatch(getActiveAdvertisementDetails(pageNumber, rowPerPage, props.year));
                case "past_advt_list":
                    return dispatch(getPastAdvertisementDetails(pageNumber, rowPerPage, props.year));
                case "cancel_reject_application_advt_list":
                    return dispatch(getAdvertisementDetails(pageNumber, rowPerPage, props.year, props.deptID));
                case "cancel_reject_application_list":
                    return dispatch(getCancelRejectApplication(props.advtID, props.action, pageNumber, rowPerPage));
                case "doc_approval_active_advt_list":
                    return dispatch(getActiveAdvertisementForDocumentApprovalList(pageNumber, rowPerPage))
                case "doc_approval_past_advt_list":
                    return dispatch(getPastAdvertisementForDocumentApprovalList(pageNumber, rowPerPage))
                case "doc_approval_all_advt_list":
                    return dispatch(getAllAdvertisementForDocumentApprovalList(pageNumber, rowPerPage))
                case "document_type_list":
                    return dispatch(getDocumentTypeListPagination(pageNumber, rowPerPage, searchCode1))
                case "qualification_type_list":
                    return dispatch(getQualificationTypeListPagination(pageNumber, rowPerPage, searchCode1))
                case "qualification_name_list":
                    return dispatch(getQualificationNameListPagination(pageNumber, rowPerPage, searchCode2, searchCode1))
                case "qualification_subject_list":
                    return dispatch(getQualSubjectTypeListPagination(pageNumber, rowPerPage, searchCode2, searchCode1))
                case "university_list":
                    return dispatch(getUniversityListPagination(pageNumber, rowPerPage, searchCode2, searchCode1, searchCode3))
                case "lookup_option_list":
                    return dispatch(getLookupOptionListPagination(pageNumber, rowPerPage, searchCode2, searchCode3, searchCode1))
                case "states_list":
                    return dispatch(getStatesListPagination(pageNumber, rowPerPage, searchCode1))
                case "district_list":
                    return dispatch(getDistrictListPagination(pageNumber, rowPerPage, searchCode2, searchCode1))
                case "taluka_list":
                    return dispatch(getTalukaListPagination(pageNumber, rowPerPage, searchCode2, searchCode1))
                case "village_list":
                    return dispatch(getVillageListPagination(pageNumber, rowPerPage, searchCode2, searchCode1))
                case "exam_subject_list":
                    return dispatch(getExamSubjectsListPagination(pageNumber, rowPerPage, searchCode1))
                case "stage_list":
                    return dispatch(getStageListPagination(pageNumber, rowPerPage, searchCode1))
                case "venue_list":
                    return dispatch(getAllApprovedVenuesListPagination(pageNumber, rowPerPage, props.searchText, props.examCenterId))
                case "data_report_list":
                    return dispatch(getAllRequisitionDataReportListPagination(pageNumber, rowPerPage))
                case "un_venue_list":
                    return dispatch(getAllApprovalVenuesListPagination(pageNumber, rowPerPage))
                case "specialisation_list":
                    return dispatch(getSpecialisationListPagination(pageNumber, rowPerPage, searchCode1, props.instId))
                case "requisition_post_list":
                    return dispatch(getRequisitionPostListPagination(pageNumber, rowPerPage, searchCode1))
                case "requisition_department_list":
                    return dispatch(getRequisitionDepartmentListPagination(pageNumber, rowPerPage, searchCode1))
                case "institution_list":
                    return dispatch(getInstitutionListPagination(pageNumber, rowPerPage, searchCode1, props.deptId))
                case "requisition_list":
                    return dispatch(getAllRequisitionListPagination(pageNumber, rowPerPage, props.requisitionPost, props.requisitionDepartment, props.requisitionGroup, '', props.requisitionType, props.requisitionStatus, props.requisitionPostType))
                case "advertisement_report_list":
                    return dispatch(getFilterAdvertisementReportListPagination(pageNumber, rowPerPage, props.departmentName, props.examType, props.postName, props.groupName, props.requiredDate, props.endDate, props.reqStage, props.reqDesk, props.reqStatus))
                case "departmentwise_report_list":
                    return dispatch(getDepartmentWiseReportListPagination(pageNumber, rowPerPage))
                case "dashboard_user_list":
                    return dispatch(getDashboardsUserListData(pageNumber, rowPerPage));
                case "attendent_list":
                    return dispatch(getAttendentListData(props.examIdForSearch, pageNumber, rowPerPage, props.attendanceList));
                case "exam_list":
                    return dispatch(getAllExamsListPagination(pageNumber, rowPerPage, searchCode1));
                case "debarred_list":
                    return dispatch(getDebarredListPagination(pageNumber, rowPerPage, searchCode1));
                case "document_download_list":
                    return dispatch(getAllDocumentListPagination(pageNumber, rowPerPage, props.selectedAdvertisementId, props.venuid, '', props.examcenterid));
                case "reupload_candidate_upload_list":
                    return dispatch(getReUploadApplicationDocList(pageNumber, rowPerPage, props.selectedAdvertisementId));
                case "reupload_candidate_download_list":
                    return dispatch(getReDownloadApplicationDocList(pageNumber, rowPerPage, props.selectedAdvertisementId));
                case "collector_attendent_list":
                    return dispatch(collectorAttendancePagination(props.examIdForSearch, pageNumber, rowPerPage, props.attendanceList));
                case "active_advt_list_challan_management":
                    return dispatch(getAdvertisement(pageNumber, rowPerPage, props.year));
                case "past_advt_list_challan_management":
                    return dispatch(getPastAdvertisement(pageNumber, rowPerPage, props.year));
                case "candidate_challan_details":
                    return dispatch(getChallanCandidates(props.id, pageNumber, rowPerPage));
                case "active_venue_advt_list":
                    return dispatch(getAllActiveVenueAdvtList(pageNumber, rowPerPage));
                case "timetable_csv_list":
                    return dispatch(getTimetableCsvList(pageNumber, rowPerPage, props.advid));
                case "all_objection_file_list":
                    return dispatch(getAllObjectionFilesData(pageNumber, rowPerPage, props.advid));
                case "pending_requisition_list":
                    return dispatch(getPendingRequisitionDataDetails(pageNumber, rowPerPage));
                case "sent_for_approval_requisition_list":
                    return dispatch(getSentForApprovalRequisitionDataDetails(pageNumber, rowPerPage));
                case "pending_approval_requisition_list":
                    return dispatch(getPendingApprovalRequisitionDataDetails(pageNumber, rowPerPage));
                case "admit_card_search_list":
                    return dispatch(getSearchAdmitCardListData(pageNumber, rowPerPage, props.advid, searchCode2));
                case "venue_advertisement_list":
                    return dispatch(getNonAssignedVenueAdvertisementListAPI(pageNumber, rowPerPage, props.year, props.examcenterid, props.advertisementtype, props.examsubjectid, props.examdate));
                case "active_venue_advertisement_list":
                    return dispatch(getVenueAdvertisementListAPI(pageNumber, rowPerPage, props.year, props.examcenterid, props.advertisementtype, props.examsubjectid, props.examdate));
                case "all_advertisement_list_pagination":
                    return dispatch(getAllAdvertisementListAPI(pageNumber, rowPerPage, props.year));
                case "all_grievance_list_pagination":
                    return dispatch(getAllGrievanceListPagination(pageNumber, rowPerPage));
                case "user_approval_list":
                    return dispatch(getAllApprovalUser(pageNumber, rowPerPage));
                case "debar_users_list":
                    return dispatch(getAllDebarUsers(pageNumber, rowPerPage));
            }
        }
    }

    const previousPageData = () => {
        if (props.onChangeValue) {
            gotoFirstPage()
            props.setonChangeValue(false);
        }

        if ((pageNumber !== 1)) {
            setPageNumber(parseInt(pageNumber) - 1);
            // eslint-disable-next-line default-case
            switch (props.paginationFor) {
                case "active_advt_list":
                    return dispatch(getActiveAdvertisementDetails((pageNumber - 1) - 1, rowPerPage, props.year));
                case "past_advt_list":
                    return dispatch(getPastAdvertisementDetails((pageNumber - 1) - 1, rowPerPage, props.year));
                case "cancel_reject_application_advt_list":
                    return dispatch(getAdvertisementDetails((pageNumber - 1) - 1, rowPerPage, props.year, props.deptID));
                case "cancel_reject_application_list":
                    return dispatch(getCancelRejectApplication(props.advtID, props.action, (pageNumber - 1) - 1, rowPerPage));
                case "doc_approval_active_advt_list":
                    return dispatch(getActiveAdvertisementForDocumentApprovalList((pageNumber - 1) - 1, rowPerPage))
                case "doc_approval_past_advt_list":
                    return dispatch(getPastAdvertisementForDocumentApprovalList((pageNumber - 1) - 1, rowPerPage))
                case "doc_approval_all_advt_list":
                    return dispatch(getAllAdvertisementForDocumentApprovalList((pageNumber - 1) - 1, rowPerPage))
                case "document_type_list":
                    return dispatch(getDocumentTypeListPagination((pageNumber - 1) - 1, rowPerPage, searchCode1))
                case "qualification_type_list":
                    return dispatch(getQualificationTypeListPagination((pageNumber - 1) - 1, rowPerPage, searchCode1))
                case "qualification_name_list":
                    return dispatch(getQualificationNameListPagination((pageNumber - 1) - 1, rowPerPage, searchCode2, searchCode1))
                case "qualification_subject_list":
                    return dispatch(getQualSubjectTypeListPagination((pageNumber - 1) - 1, rowPerPage, searchCode2, searchCode1))
                case "university_list":
                    return dispatch(getUniversityListPagination((pageNumber - 1) - 1, rowPerPage, searchCode2, searchCode1, searchCode3))
                case "lookup_option_list":
                    return dispatch(getLookupOptionListPagination((pageNumber - 1) - 1, rowPerPage, searchCode2, searchCode3, searchCode1))
                case "states_list":
                    return dispatch(getStatesListPagination((pageNumber - 1) - 1, rowPerPage, searchCode1))
                case "district_list":
                    return dispatch(getDistrictListPagination((pageNumber - 1) - 1, rowPerPage, searchCode2, searchCode1))
                case "taluka_list":
                    return dispatch(getTalukaListPagination((pageNumber - 1) - 1, rowPerPage, searchCode2, searchCode1))
                case "village_list":
                    return dispatch(getVillageListPagination((pageNumber - 1) - 1, rowPerPage, searchCode2, searchCode1))
                case "exam_subject_list":
                    return dispatch(getExamSubjectsListPagination((pageNumber - 1) - 1, rowPerPage, searchCode1))
                case "stage_list":
                    return dispatch(getStageListPagination((pageNumber - 1) - 1, rowPerPage, searchCode1))
                case "venue_list":
                    return dispatch(getAllApprovedVenuesListPagination((pageNumber - 1) - 1, rowPerPage, props.searchText, props.examCenterId))
                case "un_venue_list":
                    return dispatch(getAllApprovalVenuesListPagination((pageNumber - 1) - 1, rowPerPage))
                case "data_report_list":
                    return dispatch(getAllRequisitionDataReportListPagination((pageNumber - 1) - 1, rowPerPage))
                case "specialisation_list":
                    return dispatch(getSpecialisationListPagination((pageNumber - 1) - 1, rowPerPage, searchCode1, props.instId))
                case "requisition_post_list":
                    return dispatch(getRequisitionPostListPagination((pageNumber - 1) - 1, rowPerPage, searchCode1))
                case "requisition_department_list":
                    return dispatch(getRequisitionDepartmentListPagination((pageNumber - 1) - 1, rowPerPage, searchCode1))
                case "institution_list":
                    return dispatch(getInstitutionListPagination((pageNumber - 1) - 1, rowPerPage, searchCode1, props.deptId))
                case "requisition_list":
                    return dispatch(getAllRequisitionListPagination((pageNumber - 1) - 1, rowPerPage, props.requisitionPost, props.requisitionDepartment, props.requisitionGroup, '', props.requisitionType, props.requisitionStatus, props.requisitionPostType))
                case "advertisement_report_list":
                    return dispatch(getFilterAdvertisementReportListPagination((pageNumber - 1) - 1, rowPerPage, props.departmentName, props.examType, props.postName, props.groupName, props.requiredDate, props.endDate, props.reqStage, props.reqDesk, props.reqStatus))
                case "departmentwise_report_list":
                    return dispatch(getDepartmentWiseReportListPagination((pageNumber - 1) - 1, rowPerPage))
                case "dashboard_user_list":
                    return dispatch(getDashboardsUserListData((pageNumber - 1) - 1, rowPerPage));
                case "attendent_list":
                    return dispatch(getAttendentListData(props.examIdForSearch, (pageNumber - 1) - 1, rowPerPage, props.attendanceList));
                case "exam_list":
                    return dispatch(getAllExamsListPagination((pageNumber - 1) - 1, rowPerPage, searchCode1));
                case "debarred_list":
                    return dispatch(getDebarredListPagination((pageNumber - 1) - 1, rowPerPage, searchCode1));
                case "document_download_list":
                    return dispatch(getAllDocumentListPagination((pageNumber - 1) - 1, rowPerPage, props.selectedAdvertisementId, props.venuid, '', props.examcenterid));
                case "reupload_candidate_upload_list":
                    return dispatch(getReUploadApplicationDocList((pageNumber - 1) - 1, rowPerPage, props.selectedAdvertisementId));
                case "reupload_candidate_download_list":
                    return dispatch(getReDownloadApplicationDocList((pageNumber - 1) - 1, rowPerPage, props.selectedAdvertisementId));
                case "collector_attendent_list":
                    return dispatch(collectorAttendancePagination(props.venueCollector, (pageNumber - 1) - 1, rowPerPage, props.attendanceList));
                case "active_advt_list_challan_management":
                    return dispatch(getAdvertisement((pageNumber - 1) - 1, rowPerPage, props.year));
                case "past_advt_list_challan_management":
                    return dispatch(getPastAdvertisement((pageNumber - 1) - 1, rowPerPage, props.year));
                case "candidate_challan_details":
                    return dispatch(getChallanCandidates(props.id, (pageNumber - 1) - 1, rowPerPage));
                case "active_venue_advt_list":
                    return dispatch(getAllActiveVenueAdvtList((pageNumber - 1) - 1, rowPerPage));
                case "timetable_csv_list":
                    return dispatch(getTimetableCsvList((pageNumber - 1) - 1, rowPerPage, props.advid));
                case "all_objection_file_list":
                    return dispatch(getAllObjectionFilesData((pageNumber - 1) - 1, rowPerPage, props.advid));
                case "pending_requisition_list":
                    return dispatch(getPendingRequisitionDataDetails((pageNumber - 1) - 1, rowPerPage));
                case "sent_for_approval_requisition_list":
                    return dispatch(getSentForApprovalRequisitionDataDetails((pageNumber - 1) - 1, rowPerPage));
                case "pending_approval_requisition_list":
                    return dispatch(getPendingApprovalRequisitionDataDetails((pageNumber - 1) - 1, rowPerPage));
                case "admit_card_search_list":
                    return dispatch(getSearchAdmitCardListData((pageNumber - 1) - 1, rowPerPage, props.advid, searchCode2));
                case "venue_advertisement_list":
                    return dispatch(getNonAssignedVenueAdvertisementListAPI((pageNumber - 1) - 1, rowPerPage, props.year, props.examcenterid, props.advertisementtype, props.examsubjectid, props.examdate));
                case "active_venue_advertisement_list":
                    return dispatch(getVenueAdvertisementListAPI((pageNumber - 1) - 1, rowPerPage, props.year, props.examcenterid, props.advertisementtype, props.examsubjectid, props.examdate));
                case "all_advertisement_list_pagination":
                    return dispatch(getAllAdvertisementListAPI((pageNumber - 1) - 1, rowPerPage, props.year));
                case "all_grievance_list_pagination":
                    return dispatch(getAllGrievanceListPagination((pageNumber - 1) - 1, rowPerPage));
                case "user_approval_list":
                    return dispatch(getAllApprovalUser((pageNumber - 1) - 1, rowPerPage));
                case "debar_users_list":
                    return dispatch(getAllDebarUsers((pageNumber - 1) - 1, rowPerPage));
            }

        }
    }

    const gotoFirstPage = () => {
        setPageNumber(1);
        // eslint-disable-next-line default-case
        switch (props.paginationFor) {
            case "active_advt_list":
                return dispatch(getActiveAdvertisementDetails(0, rowPerPage, props.year));
            case "past_advt_list":
                return dispatch(getPastAdvertisementDetails(0, rowPerPage, props.year));
            case "cancel_reject_application_advt_list":
                return dispatch(getAdvertisementDetails(0, rowPerPage, props.year, props.deptID));
            case "cancel_reject_application_list":
                return dispatch(getCancelRejectApplication(props.advtID, props.action, 0, rowPerPage));
            case "doc_approval_active_advt_list":
                return dispatch(getActiveAdvertisementForDocumentApprovalList(0, rowPerPage))
            case "doc_approval_past_advt_list":
                return dispatch(getPastAdvertisementForDocumentApprovalList(0, rowPerPage))
            case "doc_approval_all_advt_list":
                return dispatch(getAllAdvertisementForDocumentApprovalList(0, rowPerPage))
            case "document_type_list":
                return dispatch(getDocumentTypeListPagination(0, rowPerPage, searchCode1))
            case "qualification_type_list":
                return dispatch(getQualificationTypeListPagination(0, rowPerPage, searchCode1))
            case "qualification_name_list":
                return dispatch(getQualificationNameListPagination(0, rowPerPage, searchCode2, searchCode1))
            case "qualification_subject_list":
                return dispatch(getQualSubjectTypeListPagination(0, rowPerPage, searchCode2, searchCode1))
            case "university_list":
                return dispatch(getUniversityListPagination(0, rowPerPage, searchCode2, searchCode1, searchCode3))
            case "lookup_option_list":
                return dispatch(getLookupOptionListPagination(0, rowPerPage, searchCode2, searchCode3, searchCode1))
            case "states_list":
                return dispatch(getStatesListPagination(0, rowPerPage, searchCode1))
            case "district_list":
                return dispatch(getDistrictListPagination(0, rowPerPage, searchCode2, searchCode1))
            case "taluka_list":
                return dispatch(getTalukaListPagination(0, rowPerPage, searchCode2, searchCode1))
            case "village_list":
                return dispatch(getVillageListPagination(0, rowPerPage, searchCode2, searchCode1))
            case "exam_subject_list":
                return dispatch(getExamSubjectsListPagination(0, rowPerPage, searchCode1))
            case "stage_list":
                return dispatch(getStageListPagination(0, rowPerPage, searchCode1))
            case "venue_list":
                return dispatch(getAllApprovedVenuesListPagination(0, rowPerPage, props.searchText, props.examCenterId))
            case "un_venue_list":
                return dispatch(getAllApprovalVenuesListPagination(0, rowPerPage))
            case "data_report_list":
                return dispatch(getAllRequisitionDataReportListPagination(0, rowPerPage))
            case "specialisation_list":
                return dispatch(getSpecialisationListPagination(0, rowPerPage, searchCode1, props.instId))
            case "requisition_post_list":
                return dispatch(getRequisitionPostListPagination(0, rowPerPage, searchCode1))
            case "requisition_department_list":
                return dispatch(getRequisitionDepartmentListPagination(0, rowPerPage, searchCode1))
            case "institution_list":
                return dispatch(getInstitutionListPagination(0, rowPerPage, searchCode1, props.deptId))
            case "requisition_list":
                return dispatch(getAllRequisitionListPagination(0, rowPerPage, props.requisitionPost, props.requisitionDepartment, props.requisitionGroup, '', props.requisitionType, props.requisitionStatus, props.requisitionPostType))
            case "advertisement_report_list":
                return dispatch(getFilterAdvertisementReportListPagination(0, rowPerPage, props.departmentName, props.examType, props.postName, props.groupName, props.requiredDate, props.endDate, props.reqStage, props.reqDesk, props.reqStatus))
            case "departmentwise_report_list":
                return dispatch(getDepartmentWiseReportListPagination(0, rowPerPage))
            case "dashboard_user_list":
                return dispatch(getDashboardsUserListData(0, rowPerPage));
            case "attendent_list":
                return dispatch(getAttendentListData(props.examIdForSearch, 0, rowPerPage, props.attendanceList));
            case "exam_list":
                return dispatch(getAllExamsListPagination(0, rowPerPage, searchCode1));
            case "debarred_list":
                return dispatch(getDebarredListPagination(0, rowPerPage, searchCode1));
            case "document_download_list":
                return dispatch(getAllDocumentListPagination(0, rowPerPage, props.selectedAdvertisementId, props.venuid, '', props.examcenterid));
            case "reupload_candidate_upload_list":
                return dispatch(getReUploadApplicationDocList(0, rowPerPage, props.selectedAdvertisementId));
            case "reupload_candidate_download_list":
                return dispatch(getReDownloadApplicationDocList(0, rowPerPage, props.selectedAdvertisementId));
            case "collector_attendent_list":
                return dispatch(collectorAttendancePagination(props.venueCollector, 0, rowPerPage, props.attendanceList));
            case "active_advt_list_challan_management":
                return dispatch(getAdvertisement(0, rowPerPage, props.year));
            case "past_advt_list_challan_management":
                return dispatch(getPastAdvertisement(0, rowPerPage, props.year));
            case "candidate_challan_details":
                return dispatch(getChallanCandidates(props.id, 0, rowPerPage));
            case "active_venue_advt_list":
                return dispatch(getAllActiveVenueAdvtList(0, rowPerPage));
            case "timetable_csv_list":
                return dispatch(getTimetableCsvList(0, rowPerPage, props.advid));
            case "all_objection_file_list":
                return dispatch(getAllObjectionFilesData(0, rowPerPage, props.advid));
            case "pending_requisition_list":
                return dispatch(getPendingRequisitionDataDetails(0, rowPerPage));
            case "sent_for_approval_requisition_list":
                return dispatch(getSentForApprovalRequisitionDataDetails(0, rowPerPage));
            case "pending_approval_requisition_list":
                return dispatch(getPendingApprovalRequisitionDataDetails(0, rowPerPage));
            case "admit_card_search_list":
                return dispatch(getSearchAdmitCardListData(0, rowPerPage, props.advid, searchCode2));
            case "venue_advertisement_list":
                return dispatch(getNonAssignedVenueAdvertisementListAPI(0, rowPerPage, props.year, props.examcenterid, props.advertisementtype, props.examsubjectid, props.examdate));
            case "active_venue_advertisement_list":
                return dispatch(getVenueAdvertisementListAPI(0, rowPerPage, props.year, props.examcenterid, props.advertisementtype, props.examsubjectid, props.examdate));
            case "all_advertisement_list_pagination":
                return dispatch(getAllAdvertisementListAPI(0, rowPerPage, props.year));
            case "all_grievance_list_pagination":
                return dispatch(getAllGrievanceListPagination(0, rowPerPage));
            case "user_approval_list":
                return dispatch(getAllApprovalUser(0, rowPerPage));
            case "debar_users_list":
                return dispatch(getAllDebarUsers(0, rowPerPage));
        }
    }

    const gotoLastPage = () => {
        setPageNumber(totalCount);
        if (pageNumber > 0) {
            // eslint-disable-next-line default-case
            switch (props.paginationFor) {
                case "active_advt_list":
                    return dispatch(getActiveAdvertisementDetails(totalCount - 1, rowPerPage, props.year));
                case "past_advt_list":
                    return dispatch(getPastAdvertisementDetails(totalCount - 1, rowPerPage, props.year));
                case "cancel_reject_application_advt_list":
                    return dispatch(getAdvertisementDetails(totalCount - 1, rowPerPage, props.year, props.deptID));
                case "cancel_reject_application_list":
                    return dispatch(getCancelRejectApplication(props.advtID, props.action, totalCount - 1, rowPerPage));
                case "doc_approval_active_advt_list":
                    return dispatch(getActiveAdvertisementForDocumentApprovalList(totalCount - 1, rowPerPage))
                case "doc_approval_past_advt_list":
                    return dispatch(getPastAdvertisementForDocumentApprovalList(totalCount - 1, rowPerPage))
                case "doc_approval_all_advt_list":
                    return dispatch(getAllAdvertisementForDocumentApprovalList(totalCount - 1, rowPerPage))
                case "document_type_list":
                    return dispatch(getDocumentTypeListPagination(totalCount - 1, rowPerPage, searchCode1))
                case "qualification_type_list":
                    return dispatch(getQualificationTypeListPagination(totalCount - 1, rowPerPage, searchCode1))
                case "qualification_name_list":
                    return dispatch(getQualificationNameListPagination(totalCount - 1, rowPerPage, searchCode2, searchCode1))
                case "qualification_subject_list":
                    return dispatch(getQualSubjectTypeListPagination(totalCount - 1, rowPerPage, searchCode2, searchCode1))
                case "university_list":
                    return dispatch(getUniversityListPagination(totalCount - 1, rowPerPage, searchCode2, searchCode1, searchCode3))
                case "lookup_option_list":
                    return dispatch(getLookupOptionListPagination(totalCount - 1, rowPerPage, searchCode2, searchCode3, searchCode1))
                case "states_list":
                    return dispatch(getStatesListPagination(totalCount - 1, rowPerPage, searchCode1))
                case "district_list":
                    return dispatch(getDistrictListPagination(totalCount - 1, rowPerPage, searchCode2, searchCode1))
                case "taluka_list":
                    return dispatch(getTalukaListPagination(totalCount - 1, rowPerPage, searchCode2, searchCode1))
                case "village_list":
                    return dispatch(getVillageListPagination(totalCount - 1, rowPerPage, searchCode2, searchCode1))
                case "exam_subject_list":
                    return dispatch(getExamSubjectsListPagination(totalCount - 1, rowPerPage, searchCode1))
                case "stage_list":
                    return dispatch(getStageListPagination(totalCount - 1, rowPerPage, searchCode1))
                case "venue_list":
                    return dispatch(getAllApprovedVenuesListPagination(totalCount - 1, rowPerPage, props.searchText, props.examCenterId))
                case "un_venue_list":
                    return dispatch(getAllApprovalVenuesListPagination(totalCount - 1, rowPerPage))
                case "data_report_list":
                    return dispatch(getAllRequisitionDataReportListPagination(totalCount - 1, rowPerPage))
                case "specialisation_list":
                    return dispatch(getSpecialisationListPagination(totalCount - 1, rowPerPage, searchCode1, props.instId))
                case "requisition_post_list":
                    return dispatch(getRequisitionPostListPagination(totalCount - 1, rowPerPage, searchCode1))
                case "requisition_department_list":
                    return dispatch(getRequisitionDepartmentListPagination(totalCount - 1, rowPerPage, searchCode1))
                case "institution_list":
                    return dispatch(getInstitutionListPagination(totalCount - 1, rowPerPage, searchCode1, props.deptId))
                case "requisition_list":
                    return dispatch(getAllRequisitionListPagination(totalCount - 1, rowPerPage, props.requisitionPost, props.requisitionDepartment, props.requisitionGroup, '', props.requisitionType, props.requisitionStatus, props.requisitionPostType))
                case "advertisement_report_list":
                    return dispatch(getFilterAdvertisementReportListPagination(totalCount - 1, rowPerPage, props.departmentName, props.examType, props.postName, props.groupName, props.requiredDate, props.endDate, props.reqStage, props.reqDesk, props.reqStatus))
                case "departmentwise_report_list":
                    return dispatch(getDepartmentWiseReportListPagination(totalCount - 1, rowPerPage))
                case "dashboard_user_list":
                    return dispatch(getDashboardsUserListData(totalCount - 1, rowPerPage));
                case "attendent_list":
                    return dispatch(getAttendentListData((props.examIdForSearch, totalCount - 1, rowPerPage, props.attendanceList)));
                case "exam_list":
                    return dispatch(getAllExamsListPagination((totalCount - 1), rowPerPage, searchCode1));
                case "debarred_list":
                    return dispatch(getDebarredListPagination((totalCount - 1), rowPerPage, searchCode1));
                case "document_download_list":
                    return dispatch(getAllDocumentListPagination((totalCount - 1), rowPerPage, props.selectedAdvertisementId, props.venuid, '', props.examcenterid));
                case "reupload_candidate_upload_list":
                    return dispatch(getReUploadApplicationDocList((totalCount - 1), rowPerPage, props.selectedAdvertisementId));
                case "reupload_candidate_download_list":
                    return dispatch(getReDownloadApplicationDocList((totalCount - 1), rowPerPage, props.selectedAdvertisementId));
                case "collector_attendent_list":
                    return dispatch(collectorAttendancePagination((props.venueCollector, totalCount - 1, rowPerPage, props.attendanceList)));
                case "active_advt_list_challan_management":
                    return dispatch(getAdvertisement(totalCount - 1, rowPerPage, props.year));
                case "past_advt_list_challan_management":
                    return dispatch(getPastAdvertisement(totalCount - 1, rowPerPage, props.year));
                case "candidate_challan_details":
                    return dispatch(getChallanCandidates(props.id, totalCount - 1, rowPerPage));
                case "active_venue_advt_list":
                    return dispatch(getAllActiveVenueAdvtList(totalCount - 1, rowPerPage));
                case "timetable_csv_list":
                    return dispatch(getTimetableCsvList(totalCount - 1, rowPerPage, props.advid));
                case "all_objection_file_list":
                    return dispatch(getAllObjectionFilesData(totalCount - 1, rowPerPage, props.advid));
                case "pending_requisition_list":
                    return dispatch(getPendingRequisitionDataDetails(totalCount - 1, rowPerPage));
                case "sent_for_approval_requisition_list":
                    return dispatch(getSentForApprovalRequisitionDataDetails(totalCount - 1, rowPerPage));
                case "pending_approval_requisition_list":
                    return dispatch(getPendingApprovalRequisitionDataDetails(totalCount - 1, rowPerPage));
                case "admit_card_search_list":
                    return dispatch(getSearchAdmitCardListData(totalCount - 1, rowPerPage, props.advid, searchCode2));
                case "venue_advertisement_list":
                    return dispatch(getNonAssignedVenueAdvertisementListAPI(totalCount - 1, rowPerPage, props.year, props.examcenterid, props.advertisementtype, props.examsubjectid, props.examdate));
                case "active_venue_advertisement_list":
                    return dispatch(getVenueAdvertisementListAPI(totalCount - 1, rowPerPage, props.year, props.examcenterid, props.advertisementtype, props.examsubjectid, props.examdate));
                case "all_advertisement_list_pagination":
                    return dispatch(getAllAdvertisementListAPI(totalCount - 1, rowPerPage, props.year));
                case "all_grievance_list_pagination":
                    return dispatch(getAllGrievanceListPagination(totalCount - 1, rowPerPage));
                case "user_approval_list":
                    return dispatch(getAllApprovalUser(totalCount - 1, rowPerPage));
                case "debar_users_list":
                    return dispatch(getAllDebarUsers(totalCount - 1, rowPerPage));
            }
        }
    }

    const gotoSelectedPage = (pageNo) => {
        setPageNumber(pageNo);

        if (pageNumber > 0) {
            // eslint-disable-next-line default-case
            switch (props.paginationFor) {
                case "active_advt_list":
                    return dispatch(getActiveAdvertisementDetails(pageNo - 1, rowPerPage, props.year));
                case "past_advt_list":
                    return dispatch(getPastAdvertisementDetails(pageNo - 1, rowPerPage, props.year));
                case "cancel_reject_application_advt_list":
                    return dispatch(getAdvertisementDetails(pageNo - 1, rowPerPage, props.year, props.deptID));
                case "cancel_reject_application_list":
                    return dispatch(getCancelRejectApplication(props.advtID, props.action, pageNo - 1, rowPerPage));
                case "doc_approval_active_advt_list":
                    return dispatch(getActiveAdvertisementForDocumentApprovalList(pageNo - 1, rowPerPage))
                case "doc_approval_past_advt_list":
                    return dispatch(getPastAdvertisementForDocumentApprovalList(pageNo - 1, rowPerPage))
                case "doc_approval_all_advt_list":
                    return dispatch(getAllAdvertisementForDocumentApprovalList(pageNo - 1, rowPerPage))
                case "document_type_list":
                    return dispatch(getDocumentTypeListPagination(pageNo - 1, rowPerPage, searchCode1))
                case "qualification_type_list":
                    return dispatch(getQualificationTypeListPagination(pageNo - 1, rowPerPage, searchCode1))
                case "qualification_name_list":
                    return dispatch(getQualificationNameListPagination(pageNo - 1, rowPerPage, searchCode2, searchCode1))
                case "qualification_subject_list":
                    return dispatch(getQualSubjectTypeListPagination(pageNo - 1, rowPerPage, searchCode2, searchCode1))
                case "university_list":
                    return dispatch(getUniversityListPagination(pageNo - 1, rowPerPage, searchCode2, searchCode1, searchCode3))
                case "lookup_option_list":
                    return dispatch(getLookupOptionListPagination(pageNo - 1, rowPerPage, searchCode2, searchCode3, searchCode1))
                case "states_list":
                    return dispatch(getStatesListPagination(pageNo - 1, rowPerPage, searchCode1))
                case "district_list":
                    return dispatch(getDistrictListPagination(pageNo - 1, rowPerPage, searchCode2, searchCode1))
                case "taluka_list":
                    return dispatch(getTalukaListPagination(pageNo - 1, rowPerPage, searchCode2, searchCode1))
                case "village_list":
                    return dispatch(getVillageListPagination(pageNo - 1, rowPerPage, searchCode2, searchCode1))
                case "exam_subject_list":
                    return dispatch(getExamSubjectsListPagination(pageNo - 1, rowPerPage, searchCode1))
                case "stage_list":
                    return dispatch(getStageListPagination(pageNo - 1, rowPerPage, searchCode1))
                case "venue_list":
                    return dispatch(getAllApprovedVenuesListPagination(pageNo - 1, rowPerPage, props.searchText, props.examCenterId))
                case "un_venue_list":
                    return dispatch(getAllApprovalVenuesListPagination(pageNo - 1, rowPerPage))
                case "data_report_list":
                    return dispatch(getAllRequisitionDataReportListPagination(pageNo - 1, rowPerPage))
                case "specialisation_list":
                    return dispatch(getSpecialisationListPagination(pageNo - 1, rowPerPage, searchCode1, props.instId))
                case "requisition_post_list":
                    return dispatch(getRequisitionPostListPagination(pageNo - 1, rowPerPage, searchCode1))
                case "requisition_department_list":
                    return dispatch(getRequisitionDepartmentListPagination(pageNo - 1, rowPerPage, searchCode1))
                case "institution_list":
                    return dispatch(getInstitutionListPagination(pageNo - 1, rowPerPage, searchCode1, props.deptId))
                case "requisition_list":
                    return dispatch(getAllRequisitionListPagination(pageNo - 1, rowPerPage, props.requisitionPost, props.requisitionDepartment, props.requisitionGroup, '', props.requisitionType, props.requisitionStatus, props.requisitionPostType))
                case "advertisement_report_list":
                    return dispatch(getFilterAdvertisementReportListPagination(pageNo - 1, rowPerPage, props.departmentName, props.examType, props.postName, props.groupName, props.requiredDate, props.endDate, props.reqStage, props.reqDesk, props.reqStatus))
                case "departmentwise_report_list":
                    return dispatch(getDepartmentWiseReportListPagination(pageNo - 1, rowPerPage))
                case "dashboard_user_list":
                    return dispatch(getDashboardsUserListData(pageNo - 1, rowPerPage));
                case "attendent_list":
                    return dispatch(getAttendentListData(props.examIdForSearch, pageNo - 1, rowPerPage, props.attendanceList));
                case "exam_list":
                    return dispatch(getAllExamsListPagination(pageNo - 1, rowPerPage, searchCode1));
                case "debarred_list":
                    return dispatch(getDebarredListPagination(pageNo - 1, rowPerPage, searchCode1));
                case "document_download_list":
                    return dispatch(getAllDocumentListPagination(pageNo - 1, rowPerPage, props.selectedAdvertisementId, props.venuid, '', props.examcenterid));
                case "reupload_candidate_upload_list":
                    return dispatch(getReUploadApplicationDocList(pageNo - 1, rowPerPage, props.selectedAdvertisementId));
                case "reupload_candidate_download_list":
                    return dispatch(getReDownloadApplicationDocList(pageNo - 1, rowPerPage, props.selectedAdvertisementId));
                case "collector_attendent_list":
                    return dispatch(collectorAttendancePagination(props.venueCollector, pageNo - 1, rowPerPage, props.attendanceList));
                case "active_advt_list_challan_management":
                    return dispatch(getAdvertisement(pageNo - 1, rowPerPage, props.year));
                case "past_advt_list_challan_management":
                    return dispatch(getPastAdvertisement(pageNo - 1, rowPerPage, props.year));
                case "candidate_challan_details":
                    return dispatch(getChallanCandidates(props.id, pageNo - 1, rowPerPage));
                case "active_venue_advt_list":
                    return dispatch(getAllActiveVenueAdvtList(pageNo - 1, rowPerPage));
                case "timetable_csv_list":
                    return dispatch(getTimetableCsvList(pageNo - 1, rowPerPage, props.advid));
                case "all_objection_file_list":
                    return dispatch(getAllObjectionFilesData(pageNo - 1, rowPerPage, props.advid));
                case "pending_requisition_list":
                    return dispatch(getPendingRequisitionDataDetails(pageNo - 1, rowPerPage));
                case "sent_for_approval_requisition_list":
                    return dispatch(getSentForApprovalRequisitionDataDetails(pageNo - 1, rowPerPage));
                case "pending_approval_requisition_list":
                    return dispatch(getPendingApprovalRequisitionDataDetails(pageNo - 1, rowPerPage));
                case "admit_card_search_list":
                    return dispatch(getSearchAdmitCardListData(pageNo - 1, rowPerPage, props.advid, searchCode2));
                case "venue_advertisement_list":
                    return dispatch(getNonAssignedVenueAdvertisementListAPI(pageNo - 1, rowPerPage, props.year, props.examcenterid, props.advertisementtype, props.examsubjectid, props.examdate));
                case "active_venue_advertisement_list":
                    return dispatch(getVenueAdvertisementListAPI(pageNo - 1, rowPerPage, props.year, props.examcenterid, props.advertisementtype, props.examsubjectid, props.examdate));
                case "all_advertisement_list_pagination":
                    return dispatch(getAllAdvertisementListAPI(pageNo - 1, rowPerPage, props.year));
                case "all_grievance_list_pagination":
                    return dispatch(getAllGrievanceListPagination(pageNo - 1, rowPerPage));
                case "user_approval_list":
                    return dispatch(getAllApprovalUser(pageNo - 1, rowPerPage));
                case "debar_users_list":
                    return dispatch(getAllDebarUsers(pageNo - 1, rowPerPage));
            }
        }
    }

    return (
        <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-left">
                <li className="page-item">
                    <a className="page-link">
                        {commonLabels.GO_TO_PAGE}&nbsp;
                        <select
                            style={{ display: 'inline-block', fontSize: 'smaller', cursor:"pointer" }}
                            name="selectedPage"
                            value={pageNumber}
                            onChange={event => gotoSelectedPage(event.target.value)}>
                            {pageCounter.map((element, index) => {
                                return <option key={index} value={element}>{element}</option>
                            })}
                        </select>
                    </a>
                </li>
                <li className={enablePrev ? 'page-item pointer' : 'page-item disabled'} onClick={() => enablePrev && gotoFirstPage()}><a className="page-link" tabIndex="-1">{"<<"}</a></li>
                <li className={enablePrev ? 'page-item pointer' : 'page-item disabled' } onClick={() => enablePrev && previousPageData()}><a className="page-link" >{"<"}</a></li>
                <li className={enableLast ? 'page-item pointer' : 'page-item disabled'} onClick={() => enableLast && nextPageData()}><a className="page-link" >{">"}</a></li>
                <li className={enableLast ? 'page-item pointer' : 'page-item disabled'} onClick={() => enableLast && gotoLastPage()}><a className="page-link" >{">>"}</a></li>
                <li className="page-item">
                    <a className="page-link" >
                        <span>
                            Page{" "}
                            <strong>{pageNumber} of {totalCount}</strong>{" "}
                        </span>
                    </a>
                </li>
            </ul>
        </nav>
    )
}

export default TablePagination;